<i18n src="../../../lib/i18n/product/locales.json"></i18n>
<template>
    <Row class="igo">
        <navbar :transparent="isTransparent" activeTo="/Services"></navbar>
        <section class="igo-product-banner">
            <div class="igo-product-banner-bg">
                <div class="igo-product-banner-page">
                    <h1 class="banner-title">{{$t('cable_details_page_banner_title')}}</h1>
                    <p class="banner-content">{{$t('cable_details_page_banner_sm_title')}}</p>
                </div>
            </div>
        </section>
        <section class="igo-product-page">
            <div class="igo-product-buy-page">
                <i-col :lg="13" :md="13" :sm="24" :xs="24" class="igo-product-buy-page-img">
                    <img src="../../../assets/igo/cable_1.png" width="75%">
                </i-col>
                <i-col :lg="11" :md="11" :sm="24" :xs="24" class="igo-product-buy-page-dail">
                    <div class="igo-product-buy-page-title">
                        <h1>{{$t('cable_details_page_banner_title')}}</h1>
                    </div>
                    <div class="igo-product-buy-page-price">
                        <p>${{goods_info.goods_price}}</p>
                    </div>
                    <div class="igo-product-buy-page-details">
                        <p>{{$t('cable_details_page_product_content')}}</p>
                    </div>
                    <buy :id="parseInt($route.query.id)" :maxCount="parseInt(goods_info.store_count)"></buy>
                </i-col>
            </div>
        </section>
        <div style="clear: both"></div>
        <section class="igo-product-details">
            <div class="igo-product-details-page max_width">
                <h1>{{$t('cable_details_page_advantage1')}}</h1>
                <p>{{$t('cable_details_page_advantage1_content')}}</p>
                <div class="igo-product-details-img">
                    <img src="../../../assets/igo/cable_bg_2.png" width="82%"/>
                    <p class="ios-description">{{$t('cable_details_page_advantage1_content1')}}</p>
                    <p class="android-description">{{$t('cable_details_page_advantage1_content2')}}</p>
                </div>
            </div>
            <div class="igo-product-details-page" style="background: #FFFFFF">
                <h1>{{$t('cable_details_page_advantage2')}}</h1>
                <div>
                    <p>{{$t('cable_details_page_advantage2_content')}}</p>
                    <p>{{$t('cable_details_page_advantage2_content1')}}</p>
                    <p>{{$t('cable_details_page_advantage2_content2')}}</p>
                </div>
                <img class="cable-img-1" src="../../../assets/igo/cable_bg_3.jpg" width="50%"/>
            </div>
            <div class="igo-product-details-page" style="background: #FFFFFF">
                <div class="igo-product-details-page-tip">
                    <img src="../../../assets/igo/icon_1.png">
                    <h1>{{$t('cable_details_page_advantage3')}}<br>{{$t('cable_details_page_advantage4')}}</h1>
                </div>
            </div>
            <div class="Product-content">
                <div class="Product-content" style="background-image: linear-gradient(120deg, #FFFFFF 0%, #FDFDFD 30%,#E7E8E9 100%);padding:10% 0 10% 0;">
                    <Row style="padding:0 10% 0 10%" class="max_width">
                        <Col class="Product-right" :md="12" style="text-align: left;">
                        <ul class="Parameter">
                            <li>{{$t('details_page_product_parameters')}}</li>
                            <li>{{$t('cable_details_page_product_parameters1')}}</li>
                            <li>{{$t('cable_details_page_product_parameters2')}}</li>
                            <li>{{$t('cable_details_page_product_parameters3')}}</li>
                            <li>{{$t('cable_details_page_product_parameters4')}}</li>
                            <li>{{$t('cable_details_page_product_parameters5')}}</li>
                            <li>{{$t('cable_details_page_product_parameters6')}}</li>
                            <li>{{$t('cable_details_page_product_parameters7')}}</li>
                            <li>{{$t('cable_details_page_product_parameters8')}}</li>
                        </ul>
                        </Col>
                        <Col class="Product-left" :md="12" style="text-align: center;">
                        <img src="../../../assets/igo/cable_details.png" class="idual-img" width="100%">
                        </Col>
                    </Row>
                </div>
            </div>
            <div class="igo-product-details-footer">
                <p style="color: #0084ff">{{$t('shopping_notes')}}</p>
                <p>{{$t('shopping_notes_tip')}}</p>
                <guess></guess>
            </div>
            <BackTop>
                <div class="top">
                    <img src="../../../assets/backtop/top.png">
                    <p style="">{{$t('top_btn')}}</p>
                </div>
            </BackTop>
            <a href="http://ifree.ly/support" target="_blank">
                <BackTop :height="100" :bottom="110">
                    <div class="top">
                        <img src="../../../assets/backtop/service.png">
                        <p>{{$t('Service_btn')}}</p>
                    </div>
                </BackTop>
            </a>
        </section>
    </Row>
</template>

<script>
    import navbar from '../../Common/Navbar.vue'
    import guess from '../../Profiler/Common/Guess.vue'
    import buy from '../../Common/Buy.vue'
    import Signature from '../../../lib/Signature'

    export default {
        data () {
            return {
                isTransparent: false,
                minus_text: 1,
                goods_info: {}
            }
        },
        components: {
            navbar, guess, buy
        },
        created () {
            let module = 'index.php/index/goods/goodsinfo'
            let data = {}
            data.sub_time = Signature.timestamp()
            data.sign = Signature.create(module, data.sub_time)
            data.user_id = this.Local.getUserId()
            data.token = this.Local.getUserToken()
            data.lang = this.$i18n.locale
            data.goods_id = this.$route.params.id || this.$route.query.id
            this.$http.get(process.env.BASEURL + module, {
                params: data
            }).then(function (resp) {
                if (parseInt(resp.data.code) === 2000) {
                    this.goods_info = resp.data.data.goods_info
                }
            }.bind(this))
        },
        methods: {
            minus: function () {
                if (this.minus_text > 1) {
                    this.minus_text--
                }
            },
            add: function () {
                if (this.minus_text < 99) {
                    this.minus_text++
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../scss/igo/cable.scss";
</style>



// WEBPACK FOOTER //
// Cable.vue?fe36eafc